import { FacebookAuthProvider, signInWithPopup } from "firebase/auth";
import { authentication } from "./Firebase";

const  provider = new FacebookAuthProvider();
 
export const SignInWithFacebook = () => signInWithPopup(authentication, provider).then((result) => {
    return result;
  }).catch((error) => {
    return error;
  });